import { QueryHookOptions } from "@apollo/client";

import { GoalDetailsBreakdownQuery, GoalDetailsBreakdownQueryVariables } from "@ctypes";
import { GOAL_DETAILS_BREAKDOWN } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useGoalDetailsBreakdown = (
  options?: QueryHookOptions<GoalDetailsBreakdownQuery, GoalDetailsBreakdownQueryVariables>,
) => {
  return useQuery<GoalDetailsBreakdownQuery, GoalDetailsBreakdownQueryVariables>(
    GOAL_DETAILS_BREAKDOWN,
    {
      fetchPolicy: "cache-and-network",
      ...options,
    },
  );
};
